<template>
  <div class="MachMalfunction">
    <div class="container-fluid">
      <div
        class="row col-12 p-0 m-0 mt-4"
        style="font-size: 20px; font-weight: bold"
      >
        <span class="m-auto">機台故障</span>
      </div>
      <div class="col-12 row text-left">
        <div class="mb-2" style="margin-top: 10px; width: 240px">
          <div class="mx-2">
            <p class style="display: inline">機台</p>
            <b-form-select
              v-model="selected_machine"
              :options="options_machine"
              class
              style="width: calc(100% - 36px)"
            >
              <!-- 第一個選項 -->
              <template v-slot:first>
                <b-form-select-option :value="null" disabled
                  >-- 請選擇機台 --</b-form-select-option
                >
              </template>
            </b-form-select>
          </div>
        </div>
        <div
          v-if="selected_machine != null"
          class="mb-2 my-auto"
          style="margin-top: 10px"
        >
          <div class="mx-2">
            <p style="display: inline">機台現況:{{ status }}</p>
          </div>
        </div>
      </div>
      <div class="col-12 row text-left" style="width: 270px">
        <div class="mb-2" style="width: 240px">
          <div class="mx-2">
            <p class style="display: inline">狀態</p>
            <b-form-select
              v-model="selected_status"
              :options="options_status"
              class
              style="width: calc(100% - 36px)"
            >
              <!-- 第一個選項 -->
              <template v-slot:first>
                <b-form-select-option :value="null" disabled
                  >-- 請選擇狀況 --</b-form-select-option
                >
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-12 mx-2 pl-0 text-right" style="width: 100px">
          <b-button
            variant="primary"
            @click="setMachineStatus"
            style="background-color: #427ace; width: 100px"
            >修改</b-button
          >
        </div>
      </div>
      <div class="col-12 row"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MachMalfunction",
  data() {
    return {
      status: "",
      status_detail: {
        Q: "正常",
        H: "故障"
      },
      selected_machine: null,
      options_machine: [],
      selected_status: null,
      options_status: [
        { value: "Q", text: "正常" },
        { value: "H", text: "故障" }
      ],
      machine_status: {}
    };
  },
  created: function() {
    this.change_selectPage("machmalfunction");
    this.change_selectPageName(this.pageName.machmalfunction);
    this.getMachineData();
  },
  mounted: function() {},
  components: {},
  watch: {
    selected_machine: {
      handler() {
        let vm = this;
        vm.status = vm.status_detail[vm.machine_status[vm.selected_machine]];
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      pageName: "getlogin/get_pageName",
      selectPage: "getlogin/get_selectPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal"
    }),
    getMachineData() {
      let vm = this;
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        vm.searching = false;
        var result = vm.axiosResult;
        console.log(result);
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"];
          result_Data.forEach(element => {
            vm.options_machine.push({
              value: element.device_name,
              text: element.device_name
            });
            vm.machine_status[element.device_name] = element.machine_status;
          });
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    },
    setMachineStatus() {
      let vm = this;
      if (vm.selected_machine != null && vm.selected_status != null) {
        vm.trigger_loadScreenModal();
        var params = {};
        params["vuePage"] = vm.selectPage;
        params["methods"] = "PATCH";
        params["whichFunction"] = "StatusUpdate";
        params["device_name"] = vm.selected_machine;
        params["machine_status"] = vm.selected_status;
        vm.axiosAction(params).then(() => {
          vm.hide_loadScreenModal();
          vm.searching = false;
          var result = vm.axiosResult;
          console.log(result);
          if (result["Response"] == "ok") {
            vm.status = vm.status_detail[vm.selected_status];
            vm.machine_status[vm.selected_machine] = [vm.selected_status];
            vm.selected_status = null;
          } else if (result["Response"] == "no data") {
            vm.set_alertMsg("查無資料");
            vm.settimeout_alertModal();
          } else {
            vm.set_alertMsg(result["Response"]);
            vm.settimeout_alertModal();
          }
        });
      } else {
        vm.set_alertMsg("請選擇狀況/機台"); 
        vm.settimeout_alertModal();
      }
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    // this.clearTimer();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/MachMalfunction.vue